var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import $livequeueConsultationsStore from '@core/src/store/livequeueConsultationsStore';
import MediaViewerModal from '@library/media/MediaViewer.modal';
import { getIconByAttachmentType } from '@nedoShared/features/chat/utils/getIconByAttachmentType';
import { resourceExtractorNew } from '@modules/_LEGACY_/fhir/extractor';
import { $psResources } from '@store';
import { ChatMessageProviderBase } from '../ChatMessageProviderBase/ChatMessageProviderBase';
import styles from './ProviderAttachmentsPostVisits.module.scss';
export const ProviderAttachmentPostVisit = ({ message, containerClass, consultation }) => {
    const { t } = useTranslation();
    const newMessage = Object.assign(Object.assign({}, message), { content: t('label.here_your_medication_prescription') });
    const events = $livequeueConsultationsStore.documentsEvents;
    const handleClick = (subtypes) => __awaiter(void 0, void 0, void 0, function* () {
        const filtered = events.filter((e) => Array.isArray(e.subtype) && subtypes.some((s) => e.subtype.includes(s)));
        if (!filtered.length)
            return;
        const mediaItems = filtered
            .map((event) => {
            const resource = $psResources.getById(event.id);
            if (!resource)
                return null;
            const extracted = resourceExtractorNew(resource);
            const { content, asString } = extracted;
            return Object.assign(Object.assign({}, content === null || content === void 0 ? void 0 : content.attachment), { id: event.id, effectiveDate: event.effectiveDate, title: asString.typeDescription || asString.full, source: { event, resource, extractor: extracted } });
        })
            .filter(Boolean);
        if (mediaItems.length) {
            $modal.add(MediaViewerModal, { selectedIndex: 0, items: mediaItems });
        }
    });
    const getType = (type) => {
        if (!type)
            return [];
        if (type === 'post_visit_notes') {
            return ['post_visit_note_document_type', 'post_visit_note_internal_document_type'];
        }
        if (type === 'medication_prescription') {
            return ['medication_prescription_document_type'];
        }
        return [];
    };
    const displayedAttachments = (message.attachments || []).filter((attachment) => {
        const subtypes = getType(attachment.type);
        if (!subtypes.length)
            return false;
        return events.some((e) => Array.isArray(e.subtype) && subtypes.some((s) => e.subtype.includes(s)));
    });
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: cn(containerClass, styles.items) }, { children: displayedAttachments.map((attachment, i) => (_jsx("div", Object.assign({ className: containerClass, onClick: () => handleClick([...getType(attachment.type)]) }, { children: _jsxs("div", Object.assign({ className: cn(styles.cardProvider) }, { children: [_jsx("div", Object.assign({ className: styles.checkMark }, { children: _jsx(Icon, { type: "checkGreen" }) })), _jsx("div", Object.assign({ className: styles.icon }, { children: getIconByAttachmentType(attachment.type) })), _jsx("div", Object.assign({ className: styles.text }, { children: t(`label.${attachment.type}`) }))] })) }), i))) })), _jsx(ChatMessageProviderBase, { message: newMessage, hiddenText: t('label.system_message_visble_for_patient'), isOutcome: true, containerClass: containerClass })] }));
};
